import { Link, useLocation, type LinkProps } from "react-router-dom";
import { buildAuthHrefFromLocation, type BuildAuthHrefOptions } from "@/utils/authNavigation";

type PostLoginAuthLinkProps = Omit<LinkProps, "to"> & BuildAuthHrefOptions;

/**
 * Auth link that preserves the current page as ?redirect= for post-login navigation.
 */
export function PostLoginAuthLink({
  mode,
  signupType,
  referralCode,
  ...linkProps
}: PostLoginAuthLinkProps) {
  const location = useLocation();
  const to = buildAuthHrefFromLocation(location, {
    mode,
    signupType,
    referralCode,
  });

  return <Link to={to} {...linkProps} />;
}
